module.exports = __webpack_public_path__ + "static/media/Header_Booking-Request-Form.19cd2a4e.png";